import { useContext } from "react";
import {
  formatViewerForDisplay,
  getViewerDisplayInfo,
} from "common-client/utils/submissions/visibilityPill";
import { AuthContext } from "../Authorization/AuthContext";
import { Icon } from "../Common/Icons/LucideIcons";
import { Tooltip } from "../Common/Tooltip";
import { Body } from "../Common/Typography";
import { Container } from "./__styles__/VisibilityPill";

export const VisibilityPill = ({ viewers }: { viewers: Array<string> }) => {
  const { admin, user, publicUser } = useContext(AuthContext);

  const isGuest = !admin && !user && !publicUser;
  if (isGuest) {
    return null;
  }

  const { displayText, hasAdditionalDetails } = getViewerDisplayInfo(viewers);

  const content = (
    <Container>
      <Icon iconName="users" color="contentSecondary" size={16} />
      <Body type="regular" size="small" color="contentSecondary">
        Shared with {displayText}
      </Body>
    </Container>
  );

  if (hasAdditionalDetails) {
    return (
      <Tooltip
        content={content}
        popoverContent={
          <>
            {viewers.map((viewer, index) => (
              <div key={index}>{formatViewerForDisplay(viewer)}</div>
            ))}
          </>
        }
        place="bottom"
        leftSpace={false}
      />
    );
  }

  return content;
};
